import { gql, TypedDocumentNode } from '@common/hooks';
import {
  ArchiveTierMutationCgResponse,
  ArchiveTierMutationVariables,
} from '@common/graphql/schema';

export const ArchiveTierMutation: TypedDocumentNode<
  ArchiveTierMutationCgResponse,
  ArchiveTierMutationVariables
> = gql`
  mutation ArchiveTier($tierId: ID!) {
    archiveTier(tierId: $tierId) {
      tier {
        id
        name
      }
      errors {
        ... on NotFoundError {
          message
        }
        ... on BadUserInputError {
          message
        }
        ... on ModelValidationError {
          message
        }
        ... on RecordNotUniqueError {
          message
        }
      }
    }
  }
`;
